module.exports = __webpack_public_path__ + "static/media/mobile.71800232.png";